module.exports = __webpack_public_path__ + "static/rs_preview-e00cd8d8ec919f692a02f9c5e03cd23d.jpg";